"use client"

import { useEffect, useState } from "react"
import DatePicker, { registerLocale } from "react-datepicker"
import ContentHeader from "../../components/ContentHeader"
import Loader from "../../components/Loader"
import Swal from "sweetalert2"
import axios from "axios"
import "datatables.net-bs4"
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css"
import "select2"
import "select2/dist/css/select2.min.css"
import { Tooltip } from "bootstrap"
import "react-datepicker/dist/react-datepicker.css"
import es from "date-fns/locale/es"
import $ from "jquery"
import { jsPDF } from "jspdf"
import autoTable from "jspdf-autotable"
import { format } from "date-fns"
import { safeCurrencyFormat } from "../../utils/currencyFormatter"

const today = new Date()

const unitsForm = new FormData();
unitsForm.append("status_filter", "2");
unitsForm.append("type_filter", "0");

// Función auxiliar para formatear números de forma segura
const safeNumberFormat = (value) => {
  if (value === null || value === undefined) return '0.00'
  const numericValue = parseFloat(value || '0')
  if (isNaN(numericValue)) return '0.00'
  return numericValue.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
registerLocale("es", es)

const totalSectionStyle = {
  background: "#033c73",
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
}

const EarningsReport = () => {
  const [loading, setLoading] = useState(false)
  const [date, setDate] = useState(new Date())
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [userRol, setUserRol] = useState(null)
  const [dataTicket, setDataTicket] = useState([])
  const [dataTicketAdmin, setDataTicketAdmin] = useState([])
  const [dataPackage, setDataPackage] = useState([])
  const [packagesToCollect, setPackagesToCollect] = useState([])
  const [packagesAdvances, setPackagesAdvances] = useState([])
  const [extraLuggage, setExtraLuggage] = useState([])
  const [dataPreTickets, setDataPreTickets] = useState([])
  const [dataOnlineTickets, setDataOnlineTickets] = useState([])
  const [dataBillsWay, setDataBillsWay] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [partners, setPartners] = useState([])
  const [selectedPartner, setSelectedPartner] = useState("")
  const [units, setUnits] = useState([])
  const [selectedUnit, setSelectedUnit] = useState("")
  const [dataPartnerBills, setDataPartnerBills] = useState([])
  const [dataPartnerBillsCasetas, setDataPartnerBillsCasetas] = useState([])
  const [dataCountTrip, setDataCountTrip] = useState(0)
  const [dataCountTripCasetas, setDataCountTripCasetas] = useState(0)
  const [dataTransfers, setDataTransfers] = useState([]) // New state for transfers
  const [dataCardPayments, setDataCardPayments] = useState([]) // New state for card payments
  const allBills = dataPartnerBillsCasetas.flatMap((partnerGroupCasetas) =>
    partnerGroupCasetas.bills.map((bill) => ({
      ...bill,
      partner_name: partnerGroupCasetas.partner_name,
      trips_count: partnerGroupCasetas.trips_count,
    })),
  )

  const totalBillsCount = allBills.length
  const [totalEarnings, setTotalEarnings] = useState(0)
  const [totalEarningsCasetas, setTotalEarningsCasetas] = useState(0)
  const [totalTransfers, setTotalTransfers] = useState(0) // New state for total transfers
  const [totalCardPayments, setTotalCardPayments] = useState(0) // New state for total card payments
  const [branches, setBranches] = useState([])
  const [selectedBranch, setSelectedBranch] = useState(0)
  const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT
  const TITLEALERT = process.env.REACT_APP_TITLE_ALERT

  const formatDate = (dateString, fieldType = "default") => {
    if (!dateString) return ""

    // Create a date object from the string
    const date = new Date(dateString)

    if (fieldType === "date_ticket") {
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    }


    // Format the date
    const day = date.getDate().toString().padStart(2, "0")
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }

  const formatTime = (timeString) => {
    if (!timeString) return ""
    const [hours, minutes] = timeString.split(":")
    const date = new Date()
    date.setHours(hours)
    date.setMinutes(minutes)
    const formattedMinutes = date.getMinutes().toString().padStart(2, "0")
    const ampm = date.getHours() >= 12 ? "PM" : "AM"
    const hours12 = date.getHours() % 12 || 12
    const formattedHours12 = hours12.toString().padStart(2, "0")
    return `${formattedHours12}:${formattedMinutes} ${ampm}`
  }

  useEffect(() => {
    const storedUser = localStorage.getItem("dataUser")
    if (!storedUser) return

    const user = JSON.parse(storedUser)
    setUserRol(user.rol_id)
    
    // Set default date range for super admins (rol_id 1 or 2)
    if (user.rol_id === 1 || user.rol_id === 2) {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      setStartDate(today);
      setEndDate(today);
    }
  }, [])

  const isAdmin = userRol === 1 || userRol === 2 || userRol === 10

  // useEffect para inicializar tooltips de Bootstrap
  useEffect(() => {
    setTimeout(() => {
      const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
      tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl))
    }, 100)
  }, [])


  useEffect(() => {
    const fetchFiltersData = async () => {
      try {
        setLoading(true)

        const [branchesRes, partnersRes, unitsRes] = await Promise.all([
          axios.get(ENDPOINT + "get-all-branchs-ticket"),
          axios.get(ENDPOINT + "get-all-partners"),
          axios.post(ENDPOINT + "get-all-units", unitsForm),
        ])

        setBranches(branchesRes.data.data.map((b) => ({
          label: b.name,
          value: b.branch_id,
        })))

        setPartners(partnersRes.data.data.map((p) => ({
          label: p.name_partner,
          value: p.partner_id.toString(),
        })))

        setUnits(unitsRes.data.data.map((u) => ({
          label: u.name,
          value: u.unit_id.toString(),
        })))
      } catch (error) {
        console.error("Error cargando filtros:", error)
      } finally {
        setLoading(false)
      }
    }

    if (isAdmin) {
      fetchFiltersData()

      // Initialize tooltips
      const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
      tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl))
    }
  }, [isAdmin])


  useEffect(() => {
    axios.get(ENDPOINT + "get-all-schedules/2")
      .then(res => setSchedules(res.data.data || []));
  }, []);

  $("#branch_id").on("change", (e) => {
    setSelectedBranch(e.target.value)
  })


  const handleOpenBinnacle = async (ticket) => {
    const form = new FormData();
    form.append('branch_id', ticket.branch_name); // Asegúrate de que este dato venga en dataTicket
    form.append('date', ticket.date); // Usa la fecha seleccionada (debe estar en formato 'YYYY-MM-DD')
    form.append('time', ticket.time);
    form.append('user_id', "1"); // Opcional, si es requerido por el backend
  
    try {
      const response = await axios.post(ENDPOINT + 'print-pdf-binnacle', form, {
        responseType: 'blob',
      });
  
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: '<div class="title-custom-alert">Error</div>',
        html: '<div class="text-custom-alert">No se pudo generar la bitácora para este viaje.</div>',
      });
    }
  };

  const handleSearch = async () => {
    console.log('handleSearch called')
    console.log('selectedPartner:', selectedPartner)
    console.log('selectedUnit:', selectedUnit)
    
    const form = new FormData()
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const day = date.getDate().toString().padStart(2, "0")
    const dateFormat = year + "-" + month + "-" + day
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const user_id = user.user_id
    
    form.append("user_id", user_id)
    // Añadir branch_id si es admin o superadmin
    if ((user.rol_id === 1 || user.rol_id === 2)) {
      form.append("branch_id", selectedBranch)
      if (selectedPartner && selectedPartner !== "0") {
        form.append("selectedPartner", selectedPartner)
      }
      if (selectedUnit && selectedUnit !== "0") {
        form.append("selectedUnit", selectedUnit)
      }
      if (startDate instanceof Date && !isNaN(startDate)) {
        const year = startDate.getFullYear();
        const month = (startDate.getMonth() + 1).toString().padStart(2, "0");
        const day = startDate.getDate().toString().padStart(2, "0");
        form.append("startDate", `${year}-${month}-${day}`);
      } else {
        form.append("startDate", "");
      }
      if (endDate instanceof Date && !isNaN(endDate)) {
        const year = endDate.getFullYear();
        const month = (endDate.getMonth() + 1).toString().padStart(2, "0");
        const day = endDate.getDate().toString().padStart(2, "0");
        form.append("endDate", `${year}-${month}-${day}`);
      } else {
        form.append("endDate", "");
      }

    }
    else{
      form.append("date", dateFormat)
    }
    setLoading(true)
    await axios
      .post(ENDPOINT + "earnings-report", form)
      .then((response) => {
        setLoading(false)
        setDataTicket(response.data.data.tickets)
        setDataTicketAdmin(response.data.data.infoTicketsAdmin)
        setDataPackage(response.data.data.packages)
        setPackagesToCollect(response.data.data.packagesToCollect)
        setPackagesAdvances(response.data.data.packagesAdvances)
        setExtraLuggage(response.data.data.extraLuggage)
        setDataPreTickets(response.data.data.preTickets)
        setDataOnlineTickets(response.data.data.onlineTickets)
        setDataBillsWay(response.data.data.bills_way || []);
        setDataPartnerBills(response.data.data.bills)
        setDataPartnerBillsCasetas(response.data.data.casetas)
        setDataCountTrip(response.data.data.tripCount)
        setDataCountTripCasetas(response.data.data.total_trips_count_casetas)

        // Set transfers and card payments data if available
        if (response.data.data.transfers) {
          setDataTransfers(response.data.data.transfers)
          setTotalTransfers(response.data.data.transfers.reduce((a, b) => a + Number.parseFloat(b.amount), 0))
        }

        if (response.data.data.cardPayments) {
          setDataCardPayments(response.data.data.cardPayments)
          setTotalCardPayments(response.data.data.cardPayments.reduce((a, b) => a + Number.parseFloat(b.amount), 0))
        }

        const total =
          response.data.data.tickets.reduce((a, b) => a + Number.parseFloat(b.total), 0) +
          response.data.data.extraLuggage.reduce((a, b) => a + Number.parseFloat(b.total), 0) +
          response.data.data.onlineTickets.reduce((a, b) => a + Number.parseFloat(b.price_ticket), 0)
        setTotalEarnings(total)
        setTotalEarningsCasetas(response.data.data.total_casetas)
      })
      .catch((error) => {
        setLoading(false)
        const errorMessage = error.response?.data?.msg ||
          error.response?.data?.message ||
          error.message ||
          'Error desconocido al procesar la solicitud';

        Swal.fire({
          icon: 'error',
          title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
          showConfirmButton: true,
          html: '<div class="text-custom-alert">' + errorMessage + '</div>',
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' }
        });
      })
  }

  const resetPage = () => {
    window.location.reload()
  }

  const handlePrint = async () => {
    setLoading(true)
    const form = new FormData()
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const day = date.getDate().toString().padStart(2, "0")
    const date_send = year + "-" + month + "-" + day
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const user_id = user.user_id
    form.append("date", date_send)
    form.append("user_id", user_id)

    // Add branch_id if admin or superadmin and a branch is selected
    if ((user.rol_id === 1 || user.rol_id === 2) && selectedBranch !== 0) {
      form.append("branch_id", selectedBranch)
    }

    await axios
      .post(ENDPOINT + "export-earnings-report", form, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
        )
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", "reporte-de-ganancias-" + date_send + ".xlsx")
        document.body.appendChild(link)
        link.click()
      })
      .catch((error) => {
        console.log(error)
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          html: '<div class="text-custom-alert">Error! No hay datos para descargar </div>',
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        })
      })
    setLoading(false)
  }

  // Nueva función para generar PDF para un socio específico
  const generatePartnerPDF = (partnerData) => {
    setLoading(true)
    try {
      // Crear nuevo documento PDF
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      })

      // Definir márgenes y dimensiones
      const pageWidth = doc.internal.pageSize.width
      const pageHeight = doc.internal.pageSize.height
      const margin = 10

      // Añadir logo de la empresa (centrado en la parte superior)
      // Nota: Esto es un placeholder, deberás reemplazar con tu logo real
      const logoWidth = 40
      const logoHeight = 40
      const logoX = (pageWidth - logoWidth) / 2
      const logoY = margin
      doc.addImage('https://salinacrucenses.com/zfiles/company/logoscok-1741893180.png', 'PNG', logoX, logoY, logoWidth, logoHeight);

      // Calcular la posición Y después del logo
      const yAfterLogo = logoY + logoHeight + 10

      // Añadir encabezado de la empresa (más compacto)
      doc.setFontSize(14)
      doc.setFont("helvetica", "bold")
      doc.text("Transportes Salinacrucenses S.C DE R.L DE C.V", pageWidth / 2, yAfterLogo, { align: "center" })

      // Añadir línea horizontal
      doc.setDrawColor(0, 60, 115) // #003c73 color
      doc.setLineWidth(0.5)
      doc.line(margin, yAfterLogo + 5, pageWidth - margin, yAfterLogo + 5)

      // Añadir información del socio (más compacto)
      const formattedStartDate = startDate ? format(startDate, "dd 'de' MMMM 'de' yyyy", { locale: es }) : "";
    const formattedEndDate = endDate ? format(endDate, "dd 'de' MMMM 'de' yyyy", { locale: es }) : "";
    const formattedDate = format(date, "dd 'de' MMMM 'de' yyyy", { locale: es })

    let fechaTexto;
    if (startDate && endDate) {
      fechaTexto = `Del ${formattedStartDate} al ${formattedEndDate}`;
    } else if (startDate) {
      fechaTexto = `Fecha: ${formattedStartDate}`;
    } 
    else if(date){
      fechaTexto=`Fecha: ${formatDate(date.toISOString().split("T")[0], "date_ticket")}`;
    }else {
      // Fallback a la fecha del partnerData o a una fecha por defecto
      const fallbackDate = partnerData.date ? format(new Date(partnerData.date), "dd 'de' MMMM 'de' yyyy", { locale: es }) : "Fecha no disponible";
      fechaTexto = fallbackDate;
    }

       // Obtener el nombre de la sucursal seleccionada
       const branchName = selectedBranch !== "0" 
       ? branches.find(b => b.value == selectedBranch)?.label 
       : "Todas las sucursales";


      // Actualizar posición Y para la información del socio
      const yAfterLine = yAfterLogo + 10

      doc.setFontSize(14)
      doc.setFont("helvetica", "bold")
      doc.text(`Reporte de Socio: ${partnerData.partner_name}`, margin, yAfterLine)
      

      doc.setFontSize(14)
      doc.setFont("helvetica", "bold")
      doc.text(fechaTexto, margin, yAfterLine + 5);
      doc.text(`Sucursal: ${branchName}`, margin, yAfterLine + 10);
      doc.text(`Total de viajes: ${partnerData.trips_count > 0 ? partnerData.trips_count : 0}`, margin, yAfterLine + 15)

      
      

      // Añadir caja coloreada con ganancias totales (más pequeña)
      doc.setFillColor(0, 60, 115) // #003c73 color
      doc.roundedRect(pageWidth - margin - 50, yAfterLine - 2, 50, 15, 2, 2, "F")

      doc.setTextColor(255, 255, 255) // Texto blanco
      doc.setFontSize(10)
      doc.text("Total de ganancias del día", pageWidth - margin - 25, yAfterLine + 3, { align: "center" })

      // Calcular ganancias totales según la vista actualizada
      // Usar totalEarnings - totalEarningsCasetas para el cálculo
      const totalPerTrip = (totalEarnings - totalEarningsCasetas) / dataCountTrip
      const totalEarningsBeforeExpenses = totalPerTrip * partnerData.trips_count
      const totalPartnerEarnings = totalEarningsBeforeExpenses - partnerData.total

      doc.setFontSize(10)
      doc.setFont("helvetica", "bold")
      doc.text(
        `$${safeNumberFormat(totalEarnings - totalEarningsCasetas)}`,
        pageWidth - margin - 25,
        yAfterLine + 10,
        { align: "center" },
      )

      // Restablecer color de texto
      doc.setTextColor(0, 0, 0)

      // Filtrar boletos del socio
      const partnerTickets = dataTicket.filter((ticket) => {
        // Buscar si la letra del boleto coincide con alguna letra del socio
        return partnerData.letters.some((letter) => letter.name === ticket.letter)
      })

      // Posición Y actual - actualizada para evitar solapamiento
      let currentY = yAfterLine + 25

      // Añadir tabla de detalles de viaje (boletos del socio)
      doc.setFontSize(10)
      doc.setFont("helvetica", "bold")
      doc.text("Detalles de Corridas", margin, currentY)
      currentY += 7

      if (partnerTickets.length > 0) {
        // Crear tabla con datos de boletos
        const ticketsColumn = ["Horario", "Sucursal", "Letra", "Conductor", "Total", "Bitácora"];

        // Extraer datos de boletos
        const ticketsRows = partnerTickets.map((ticket) => {
          return [
           
            formatTime(ticket.time || ""),
            ticket.branch_name || "N/A",
            ticket.date || "N/A",
            ticket.letter,
            ticket.driver || "",
            `$${safeNumberFormat(ticket.total)}`,
            ticket.trip_id || "",
          ]
        })

        // Añadir fila de total
        ticketsRows.push([
          "",
          "",
          "Total Boletos",
          "",
          `$${safeNumberFormat(partnerTickets.reduce((a, b) => a + Number.parseFloat(b.total || 0), 0))}`,
          "",
        ])

        // Use autoTable directly from the imported function
        autoTable(doc, {
          head: [ticketsColumn],
          body: ticketsRows,
          startY: currentY,
          theme: "grid",
          headStyles: {
            fillColor: [0, 60, 115],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 8,
          },
          bodyStyles: {
            fontSize: 8,
          },
          alternateRowStyles: {
            fillColor: [240, 240, 240],
          },
          margin: { left: margin, right: margin },
        })
      } else {
        doc.setFontSize(10)
        doc.setFont("helvetica", "normal")
        doc.text("No hay boletos registrados para este socio en la fecha seleccionada.", margin, currentY + 5)
        currentY += 10
      }

      // Actualizar posición Y
      currentY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 5 : currentY + 15

      // Añadir resumen financiero
      doc.setFontSize(10)
      doc.setFont("helvetica", "bold")
      doc.text("Detalle de Gastos", margin, currentY)
      currentY += 7

      // Crear tabla con datos de gastos
      const expensesColumn = ["Fecha", "Concepto", "Unidad", "Conductor", "Usuario", "Monto"]

      // Extraer datos de gastos
      const expensesRows = partnerData.bills.map((bill) => {
        return [
         
          formatDate(bill.date, 'date_ticket'),
          bill.concept,
          bill.unit?.name || "-",
          `${bill.driver?.name || ""} ${bill.driver?.last_name || ""}`,
          bill.user || "-",
          `$${safeNumberFormat(bill.total)}`,
        ]
      })

      // Si no hay gastos, añadir una fila indicando eso
      if (expensesRows.length === 0) {
        expensesRows.push(["", "No hay gastos registrados", "", "", "", "$0.00"])
      }

      // Añadir fila de total
      expensesRows.push([
        "",
        "Total de Gastos",
        "",
        "",
        "",
        `$${safeNumberFormat(partnerData.total)}`,
      ])

      // Use autoTable directly from the imported function
      autoTable(doc, {
        head: [expensesColumn],
        body: expensesRows,
        startY: currentY,
        theme: "grid",
        headStyles: {
          fillColor: [0, 60, 115],
          textColor: [255, 255, 255],
          fontStyle: "bold",
          fontSize: 8,
        },
        bodyStyles: {
          fontSize: 8,
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240],
        },
        margin: { left: margin, right: margin },
      })

      // Actualizar posición Y
      currentY = doc.lastAutoTable.finalY + 10

      // Añadir cálculo de ganancias (más compacto)
      doc.setFontSize(10)
      doc.setFont("helvetica", "bold")
      doc.text("Resumen de Ganancias:", margin, currentY)

      doc.setFont("helvetica", "normal")
      doc.text(
        `Total por unidad: $${safeNumberFormat(totalPerTrip)}`,
        margin + 5,
        currentY + 5,
      )
      doc.text(
        `Total por ${partnerData.trips_count} viajes: $${safeNumberFormat(totalEarningsBeforeExpenses)}`,
        margin + 5,
        currentY + 10,
      )
      doc.text(
        `Total de gastos: $${safeNumberFormat(partnerData.total)}`,
        margin + 5,
        currentY + 15,
      )

      // Caja de total a pagar (más pequeña)
      doc.setFillColor(0, 60, 115) // #003c73 color
      doc.roundedRect(pageWidth - margin - 50, currentY - 2, 50, 20, 2, 2, "F")

      doc.setTextColor(255, 255, 255) // Texto blanco
      doc.setFontSize(10)
      doc.text(`Restante en Taquilla ${branchName}`, pageWidth - margin - 25, currentY + 5, { align: "center" })

      doc.setFontSize(10)
      doc.setFont("helvetica", "bold")
      doc.text(
        `$${safeNumberFormat(totalPartnerEarnings)}`,
        pageWidth - margin - 25,
        currentY + 13,
        { align: "center" },
      )

      // Restablecer color de texto
      doc.setTextColor(0, 0, 0)

      // Verificar si hay boletos administrativos para este socio
      const adminTickets = dataTicketAdmin.filter((ticket) => {
        // Buscar si la letra del boleto coincide con alguna letra del socio
        return partnerData.letters.some((letter) => letter.name === ticket.letter)
      })

      // Solo mostrar la sección de boletos administrativos si hay al menos uno
      if (adminTickets.length > 0) {
        // Actualizar posición Y
        currentY = currentY + 30

        // Verificar si hay suficiente espacio para la tabla de boletos administrativos
        // Si no hay suficiente espacio, añadir una nueva página
        if (currentY + 40 > pageHeight - margin) {
          doc.addPage()
          currentY = margin + 10
        }

        doc.setFontSize(10)
        doc.setFont("helvetica", "bold")
        doc.text("Boletos Administrativos", margin, currentY)
        currentY += 5

        // Create table with administrative ticket data
        const adminColumn = ["Horario", "Letra", "Conductor", "Total", "Bitácora"]

        // Extract administrative ticket data
        const adminRows = adminTickets.map((ticket) => {
          return [
           
            formatTime(ticket.time || ""),
            ticket.letter,
            ticket.driver || "",
            `$${safeNumberFormat(ticket.total)}`,
            ticket.trip_id || "",
          ]
        })

        const totalAdminTickets = adminTickets.reduce((a, b) => a + Number.parseFloat(b.total || 0), 0)

        // Add total row
        adminRows.push([
          "",
          "",
          "Total Boletos Admin",
          "",
          `$${safeNumberFormat(totalAdminTickets)}`,
          "",
        ])

        const totalFinal = totalPartnerEarnings + totalAdminTickets

         // Caja de total a pagar (más pequeña)
      doc.setFillColor(0, 60, 115) // #003c73 color
      doc.roundedRect(pageWidth - margin - 50, currentY + 26, 50, 20, 2, 2, "F")

      doc.setTextColor(255, 255, 255) // Texto blanco
      doc.setFontSize(10)
      doc.text(`Total Generado`, pageWidth - margin - 25, currentY + 30, { align: "center" })

      doc.setFontSize(10)
      doc.setFont("helvetica", "bold")
      doc.text(
        `$${safeNumberFormat(totalFinal)}`,
        pageWidth - margin - 25,
        currentY + 38,
        { align: "center" },
      )
       




        // Use autoTable directly from the imported function
        autoTable(doc, {
          head: [adminColumn],
          body: adminRows,
          startY: currentY,
          theme: "grid",
          headStyles: {
            fillColor: [0, 60, 115],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 8,
          },
          bodyStyles: {
            fontSize: 8,
          },
          alternateRowStyles: {
            fillColor: [240, 240, 240],
          },
          margin: { left: margin, right: margin },
        })
      }

      // Añadir pie de página
      const pageCount = doc.internal.getNumberOfPages()

      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i)

        // Añadir número de página
        doc.setFontSize(10)
        doc.setFont("helvetica", "normal")
        doc.text(`Página ${i} de ${pageCount}`, pageWidth - margin, pageHeight - margin, { align: "right" })

        // Añadir fecha de generación
        const today = format(new Date(), "dd/MM/yyyy HH:mm")
        doc.text(`Generado el: ${today}`, margin, pageHeight - margin)

        // Añadir línea horizontal
        doc.setDrawColor(0, 60, 115) // #003c73 color
        doc.setLineWidth(0.5)
        doc.line(margin, pageHeight - margin - 5, pageWidth - margin, pageHeight - margin - 5)
      }

      // Guardar el PDF con nombre del socio y fecha
      const formattedDateFile = format(date, "dd-MM-yyyy")
      doc.save(`reporte-${partnerData.partner_name.replace(/\s+/g, "-").toLowerCase()}-${formattedStartDate}-${formattedEndDate}-${branchName}.pdf`)

      setLoading(false)
    } catch (error) {
      console.error("Error al generar PDF:", error)
      setLoading(false)
      Swal.fire({
        icon: "error",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: true,
        html: '<div class="text-custom-alert">Error al generar el PDF</div>',
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      })
    }
  }

  // Función para generar PDFs para todos los socios
  const generateAllPartnersPDFs = () => {
    if (dataPartnerBills && dataPartnerBills.length > 0) {
      dataPartnerBills.forEach((partnerData) => {
        generatePartnerPDF(partnerData)
      })
    } else {
      Swal.fire({
        icon: "info",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: true,
        html: '<div class="text-custom-alert">No hay datos de socios para generar PDFs</div>',
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      })
    }
  }

  const renderScheduleTime = (item) => {
    if (item.time) return formatTime(item.time);

    if (item.schedule_id) {
      const schedule = schedules.find(s => s.schedule_id == item.schedule_id);
      if (schedule) return formatTime(schedule.time);
    }

    if (item.horario) return formatTime(item.horario);

    return '--:--';
  };



  return (
    <div>
      {loading && <Loader />}
      <div className="container-fluid">
        <ContentHeader title="Módulo de Reportes" />
      </div>
      <div className="container-fluid">
        <div className="card">
          <div className="card-header">
            <div className="indications-header row">
              <div className="col-md-7">
                <h4 className="card-title m-0 page-title">
                  <i className="bi bi-graph-up me-2"></i> Reporte de Ganancias
                </h4>
              </div>
              <div className="col-md-5" style={{ textAlign: "right" }}>
                <button onClick={resetPage} className="btn btn-info btn-sm me-1" type="button">
                  <i className="fa fa-refresh me-1"></i> Recargar
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="row g-4 mb-4">
              <div className="col-lg-7">
                <div className="search-controls bg-light p-4 rounded-3 shadow-sm h-100">
                  <div className="add-trips-card-body">
                    <div className="mb-4">
                      <h6 className="text-muted mb-3">
                        <i className="fas fa-info-circle me-2"></i>
                        Seleccione una fecha para visualizar el reporte de ganancias
                      </h6>
                    </div>
                    <div className="row align-items-end">
                      <div className="col-md-7 mb-3 mb-md-0">
                        {!isAdmin && (
                          <>
                            <label htmlFor="date" className="form-label fw-bold mb-2">
                              <i className="far fa-calendar-alt me-2"></i>
                              Fecha del Reporte
                            </label>
                            <div className="input-group">
                              <DatePicker
                                showIcon
                                locale="es"
                                selected={date}
                                onChange={(date) => setDate(date)}
                                className="form-control form-control-sm"
                                dateFormat="dd, MMMM, yyyy"
                                placeholderText={today.toLocaleDateString("es-ES", {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric"
                                })}

                              />
                            </div>
                            <small className="text-muted mt-1 d-block">
                              La información corresponderá a la fecha seleccionada
                            </small>
                          </>
                        )}

                        {isAdmin && (
                          <div className="row mt-3">
                            {/* Fechas de inicio y fin */}
                            <div className="col-md-6 mb-3">
                              <label htmlFor="startDate" className="form-label fw-bold mb-2">
                                <i className="far fa-calendar-alt me-2"></i> Fecha Inicio
                              </label>
                              <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                className="form-control form-control-sm"
                                dateFormat="dd/MM/yyyy"
                                placeholderText={today.toLocaleDateString("es-ES", {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric"
                                })}

                                locale="es"
                              />
                            </div>

                            <div className="col-md-6 mb-3">
                              <label htmlFor="endDate" className="form-label fw-bold mb-2">
                                <i className="far fa-calendar-alt me-2"></i> Fecha Fin
                              </label>
                              <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                className="form-control form-control-sm"
                                dateFormat="dd/MM/yyyy"
                                placeholderText={today.toLocaleDateString("es-ES", {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric"
                                })}

                                locale="es"
                              />
                            </div>

                            {/* Filtros de Sucursal, Socio y Unidad */}
                            <div className="col-md-4 mb-3">
                              <label htmlFor="branch" className="form-label fw-bold mb-2">
                                <i className="fas fa-building me-2"></i> Sucursal
                              </label>
                              <select
                                id="branch_id"
                                name="branch_id"
                                className="form-control form-control-sm select2 w-100"
                                value={selectedBranch}
                                onChange={(e) => setSelectedBranch(e.target.value)}
                              >
                                <option value="0">Todas las sucursales</option>
                                {branches.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                              <small className="text-muted mt-1 d-block">Filtrar por sucursal específica</small>
                            </div>

                            <div className="col-md-4 mb-3">
                              <label htmlFor="partner" className="form-label fw-bold mb-2">
                                <i className="fas fa-user-friends me-2"></i> Socio
                              </label>
                              <select
                                id="partner_id"
                                name="partner_id"
                                className="form-control form-control-sm w-100"
                                value={selectedPartner}
                                onChange={(e) => {
                                  console.log('Partner selected:', e.target.value);
                                  setSelectedPartner(e.target.value);
                                }}
                              >
                                <option value="0">Todos los socios</option>
                                {partners.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                              <small className="text-muted mt-1 d-block">Filtrar por socio específico</small>
                            </div>

                            <div className="col-md-4 mb-3">
                              <label htmlFor="unit" className="form-label fw-bold mb-2">
                                <i className="fas fa-bus me-2"></i> Unidad
                              </label>
                              <select
                                id="unit_id"
                                name="unit_id"
                                className="form-control form-control-sm w-100"
                                value={selectedUnit}
                                onChange={(e) => {
                                  console.log('Unit selected:', e.target.value);
                                  setSelectedUnit(e.target.value);
                                }}
                              >
                                <option value="0">Todas las unidades</option>
                                {units.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                              <small className="text-muted mt-1 d-block">Filtrar por unidad específica</small>
                            </div>
                          </div>
                        )}


                      </div>
                      <div className="col-md-5">
                        <div className="d-grid gap-2">
                          <button
                            onClick={() => handleSearch()}
                            className="btn btn-primary btn-sm d-flex align-items-center justify-content-center py-2"
                          >
                            <i className="fa fa-search me-2"></i> Buscar
                          </button>
                          <button
                            onClick={() => handlePrint()}
                            className="btn btn-success btn-sm d-flex align-items-center justify-content-center py-2"
                          >
                            <i className="fa-solid fa-file-excel me-2"></i> Exportar Excel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="cash-cut-summary h-100 text-white p-4 rounded-3 shadow position-relative overflow-hidden">
                  <div className="position-relative z-1">
                    <h6 className="text-white-50 mb-3">Total de ganancias del día</h6>
                    <h2 className="display-4 fw-bold mb-0">
                      ${safeNumberFormat(totalEarnings)}
                    </h2>
                    <p className="mb-0 mt-2 text-white-50">
                      valor ventas descontando casetas:{" "}
                      {safeNumberFormat(totalEarnings - totalEarningsCasetas)}
                    </p>
                    <p className="mb-0 mt-2 text-white-50">
      <i className="fas fa-calendar-day me-1"></i>
      {isAdmin && startDate && endDate ? (
        // Mostrar rango de fechas para admin
        `Del ${formatDate(startDate.toISOString().split("T")[0], "date_ticket")} al ${formatDate(endDate.toISOString().split("T")[0], "date_ticket")}`
      ) : (
        // Mostrar fecha simple para no-admin
        date.toLocaleDateString("es-ES", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      )}
    </p>
                  </div>
                  <div className="position-absolute bottom-0 end-0 p-4 opacity-25">
                    <i className="fas fa-chart-line" style={{ fontSize: "5rem" }}></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-ticket-alt me-2"></i>
                  Boletos del Día
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Registro detallado de todos los boletos vendidos durante el día seleccionado.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Boletos</small>
                <h4 className="m-0">
                  $
                  {safeNumberFormat(dataTicket.reduce((a, b) => a + Number.parseFloat(b.total || 0), 0))}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-ticket-alt me-2"></i> Boletos
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="10%" className="text-center">
                        Horario
                      </th>
                      <th width="15%" className="text-center">
                        Base
                      </th>
                      <th width="20%" className="text-center">
                        Conductor
                      </th>
                      <th width="15%" className="text-center">
                        Letra
                      </th>
                      <th width="13%" className="text-center">
                        Total
                      </th>
                      <th width="13%" className="text-center">
                        Bitacora
                      </th>
                      <th width="14%" className="text-center">Acción</th>
                    </tr>
                  </thead>
                  {dataTicket ? (
                    <tbody>
                      {dataTicket.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{formatTime(item.time)}</td>
                          <td className="text-center">{item.branch_name || 'N/A'}</td> 
                          <td className="text-center">{item.driver}</td>
                          <td className="text-center">{item.letter}</td>
                          <td className="text-center">
                            $
                            {safeNumberFormat(item.total)}
                          </td>
                          <td className="text-center">{item.trip_id}</td>
                          <td className="text-center">
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => handleOpenBinnacle(item)}
            title="Ver Bitácora de Viaje"
          >
            <i className="fas fa-file-pdf"></i> Bitácora
          </button>
        </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="4" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {safeNumberFormat(dataTicket.reduce((a, b) => a + Number.parseFloat(b.total || 0), 0))}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    "No hay datos para mostrar"
                  )}
                </table>
              </div>
            </div>

            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-suitcase me-2"></i>
                  Equipaje Extra
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Registro de cargos adicionales por equipaje extra de pasajeros.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Equipaje Extra</small>
                <h4 className="m-0">
                  $
                  {safeNumberFormat(extraLuggage.reduce((a, b) => a + Number.parseFloat(b.total || 0), 0))}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-suitcase me-2"></i> Equipaje extra
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover main table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="20%" className="text-center">
                        Horario
                      </th>
                      <th width="20%" className="text-center">
                        Conductor
                      </th>
                      <th width="20%" className="text-center">
                        Letra
                      </th>
                      <th width="20%" className="text-center">
                        Total
                      </th>
                      <th width="20%" className="text-center">
                        Bitacora
                      </th>
                    </tr>
                  </thead>
                  {extraLuggage ? (
                    <tbody>
                      {extraLuggage.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{formatTime(item.time)}</td>
                          <td className="text-center">{item.driver}</td>
                          <td className="text-center">{item.letter}</td>
                          <td className="text-center">
                            $
                            {safeNumberFormat(item.total)}
                          </td>
                          <td className="text-center">{item.trip_id}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="3" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {safeNumberFormat(extraLuggage.reduce((a, b) => a + Number.parseFloat(b.total || 0), 0))}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    "No hay datos para mostrar"
                  )}
                </table>
              </div>
            </div>

            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-globe me-2"></i>
                  Boletos Vendidos Online
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Detalle de las ventas de boletos realizadas a través de la plataforma en línea.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Online</small>
                <h4 className="m-0">
                  $
                  {safeNumberFormat(dataOnlineTickets.reduce((a, b) => a + Number.parseFloat(b.price_ticket || 0), 0))}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-globe me-2"></i> Boletos Vendidos Online
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover main table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="20%" className="text-center">
                        Folio
                      </th>
                      <th width="20%" className="text-center">
                        Fecha de Viaje
                      </th>
                      <th width="20%" className="text-center">
                        Horario
                      </th>
                      <th width="20%" className="text-center">
                        Precio
                      </th>
                      <th width="20%" className="text-center">
                        Vendedor
                      </th>
                    </tr>
                  </thead>
                  {dataOnlineTickets ? (
                    <tbody>
                      {dataOnlineTickets.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{item.invoice}</td>
                          <td className="text-center">{formatDate(item.date_ticket)}</td>
                          <td className="text-center">{formatTime(item.time_ticket)}</td>
                          <td className="text-center">
                            $
                            {safeNumberFormat(item.price_ticket)}
                          </td>
                          <td className="text-center">{item.seller}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="3" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {safeNumberFormat(dataOnlineTickets.reduce((a, b) => a + Number.parseFloat(b.price_ticket || 0), 0))}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    "No hay datos para mostrar"
                  )}
                </table>
              </div>
            </div>
            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-flag-checkered me-2"></i>
                  Reporte de Casetas
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Resumen de los costos de las casetas generadas por cada socio en la fecha seleccionada.
                </p>
              </div>
              <div className="d-flex gap-3">
                <div className="total-section text-white rounded-3 p-3 shadow-sm text-center" style={totalSectionStyle}>
                  <small className="d-block mb-1 text-white-50">
                    <i className="fas fa-bus me-1"></i> Total Viajes
                  </small>
                  <h4 className="m-0">{totalBillsCount}</h4>
                </div>
                <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                  <small className="d-block mb-1 text-white-50">
                    <i className="fas fa-coins me-1"></i> Total por Unidad
                  </small>
                  <h4 className="m-0">
                    $
                    {totalEarningsCasetas > 0
                      ? safeNumberFormat(totalEarningsCasetas)
                      : "0.00"}
                  </h4>
                </div>
              </div>
            </div>

            {dataPartnerBillsCasetas ? (
              <div className="card mt-2">
                <div className="card-body">
                  <table className="table table-hover table-striped table-responsive">
                    <thead>
                      <tr>
                        <th width="12%" className="text-center">
                          Socio
                        </th>
                        <th width="12%" className="text-center">
                          Fecha
                        </th>
                        <th width="12%" className="text-center">
                          Concepto
                        </th>
                        <th width="12%" className="text-center">
                          Unidad
                        </th>
                        <th width="12%" className="text-center">
                          Conductor
                        </th>
                        <th width="12%" className="text-center">
                          Usuario
                        </th>
                        <th width="12%" className="text-center">
                          Monto
                        </th>
                        <th width="12%" className="text-center">
                          Letras
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataPartnerBillsCasetas
                        .flatMap((partnerGroupCasetas) =>
                          partnerGroupCasetas.bills.map((bill, billIndex) => ({
                            ...bill,
                            partner_name: partnerGroupCasetas.partner_name,
                            trips_count: partnerGroupCasetas.trips_count,
                          })),
                        )
                        .map((bill, index) => (
                          <tr key={index}>
                            <td className="text-center">{bill.partner_name}</td>
                            <td className="text-center">{formatDate(bill.date, "date_ticket")}</td>
                            <td className="text-center">{bill.concept}</td>
                            <td className="text-center">{bill.unit?.name || "-"}</td>
                            <td className="text-center">{bill.driver?.name + " " + bill.driver?.last_name || "-"}</td>
                            <td className="text-center">{bill.user || "-"}</td>
                            <td className="text-center">
                              $
                              {safeNumberFormat(bill.total)}
                            </td>
                            <td className="text-center">{bill.trips_count}</td>
                          </tr>
                        ))}

                      {/* Fila de totales */}
                      <tr className="table-active">
                        <td colSpan="6" className="text-end">
                          <strong>Total General</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {safeNumberFormat(dataPartnerBillsCasetas
                              .reduce(
                                (acc, partner) =>
                                  acc + partner.bills.reduce((sum, bill) => sum + Number.parseFloat(bill.total || 0), 0),
                                0,
                              ))}
                          </strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            {totalBillsCount}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="card mt-2">
                <div className="card-body text-center">No hay datos de casetas para mostrar</div>
              </div>
            )}
            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-chart-line me-2"></i>
                  Reporte de Ganancias por Socio
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Resumen de las ganancias generadas por cada socio en la fecha seleccionada.
                </p>
              </div>
              <div className="d-flex gap-3">
                <div className="total-section text-white rounded-3 p-3 shadow-sm text-center" style={totalSectionStyle}>
                  <small className="d-block mb-1 text-white-50">
                    <i className="fas fa-bus me-1"></i> Total Viajes
                  </small>
                  <h4 className="m-0">{dataCountTrip > 0 ? dataCountTrip : 0}</h4>
                </div>
                <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                  <small className="d-block mb-1 text-white-50">
                    <i className="fas fa-coins me-1"></i> Total por Unidad
                  </small>
                  <h4 className="m-0">
                    $
                    {totalEarnings > 0
                      ? safeNumberFormat((totalEarnings - totalEarningsCasetas) / dataCountTrip)
                      : "0.00"}
                  </h4>
                </div>
                <button
                  onClick={generateAllPartnersPDFs}
                  className="btn btn-danger"
                  style={{ backgroundColor: "#033c73", border: "none" }}
                  disabled={!dataPartnerBills || dataPartnerBills.length === 0}
                >
                  <i className="fas fa-file-pdf me-2"></i> Exportar PDFs
                </button>
              </div>
            </div>

            {dataPartnerBills ? (
              <div>
                {dataPartnerBills.map((partnerGroup, index) => {
                  const totalUnitPerTrip =
                    ((totalEarnings - totalEarningsCasetas) / dataCountTrip) * partnerGroup.trips_count
                  const totalBills = partnerGroup.bills.reduce((acc, bill) => acc + Number.parseFloat(bill.total), 0)
                  const totalPartner = totalUnitPerTrip - totalBills

                  return (
                    <div className="card mt-2" key={index}>
                      <div className="card-header">
                        <div className="d-flex justify-content-between align-items-center">
                          <h4 className="card-title m-0 page-sub-title">
                            <i className="fas fa-user-tie me-2"></i>
                            {partnerGroup.partner_name}
                          </h4>
                          <div className="d-flex gap-3">
                            <div
                              className="total-section text-white rounded-3 p-3 shadow-sm text-center"
                              style={totalSectionStyle}
                            >
                              <small className="d-block mb-1 text-white-50">
                                <i className="fas fa-bus me-1"></i> Total Letras
                              </small>
                              <h4 className="m-0">{partnerGroup.trips_count}</h4>
                            </div>
                            <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                              <small className="d-block mb-1 text-white-50">Total Socio</small>
                              <h4 className="m-0">
                                $
                                {safeNumberFormat(totalUnitPerTrip)}
                              </h4>
                            </div>
                            <button
                              onClick={() => generatePartnerPDF(partnerGroup)}
                              className="btn btn-primary"
                              style={{ backgroundColor: "#033c73", border: "none" }}
                            >
                              <i className="fas fa-file-pdf me-2"></i> Exportar PDF
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <table className="table table-hover table-striped table-responsive">
                          <thead>
                            <tr>
                              <th width="16%" className="text-center">
                                Fecha
                              </th>
                              <th width="16%" className="text-center">
                                Concepto
                              </th>
                              <th width="16%" className="text-center">
                                Unidad
                              </th>
                              <th width="16%" className="text-center">
                                Conductor
                              </th>
                              <th width="16%" className="text-center">
                                Usuario
                              </th>
                              <th width="16%" className="text-center">
                                Monto
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {partnerGroup.bills.map((bill, billIndex) => (
                              <tr key={billIndex}>
                                <td className="text-center">{formatDate(bill.date, 'date_ticket')}</td>
                                <td className="text-center">{bill.concept}</td>
                                <td className="text-center">{bill.unit.name || "-"}</td>
                                <td className="text-center">{bill.driver.name + " " + bill.driver.last_name || "-"}</td>
                                <td className="text-center">{bill.user || "-"}</td>
                                <td className="text-center">
                                  $
                                  {safeNumberFormat(bill.total)}
                                </td>
                              </tr>
                            ))}
                            <tr>
                              <td colSpan="5" className="text-end">
                                <strong>Total</strong>
                              </td>
                              <td className="text-center">
                                <strong>
                                  $
                                  {safeNumberFormat(totalPartner)}
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )
                })}
              </div>
            ) : (
              <div className="card mt-2">
                <div className="card-body text-center">No hay datos de socios para mostrar</div>
              </div>
            )}
            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-ticket-alt me-2"></i>
                  Boletos del Día Administración
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Registro de boletos vendidos Administración.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Boletos Administración</small>
                <h4 className="m-0">
                  $
                  {safeNumberFormat(dataTicketAdmin.reduce((a, b) => a + Number.parseFloat(b.total || 0), 0))}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-ticket-alt me-2"></i> Boletos Administración
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="20%" className="text-center">
                        Horario
                      </th>
                      <th width="20%" className="text-center">
                        Conductor
                      </th>
                      <th width="20%" className="text-center">
                        Letra
                      </th>
                      <th width="20%" className="text-center">
                        Total
                      </th>
                      <th width="20%" className="text-center">
                        Bitacora
                      </th>
                    </tr>
                  </thead>
                  {dataTicketAdmin ? (
                    <tbody>
                      {dataTicketAdmin.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{formatTime(item.time)}</td>
                          <td className="text-center">{item.driver}</td>
                          <td className="text-center">{item.letter}</td>
                          <td className="text-center">
                            $
                            {safeNumberFormat(item.total)}
                          </td>
                          <td className="text-center">{item.trip_id}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="3" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {safeNumberFormat(dataTicketAdmin.reduce((a, b) => a + Number.parseFloat(b.total || 0), 0))}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    "No hay datos para mostrar"
                  )}
                </table>
              </div>
            </div>

            {/* Sección de Ingresos por Camino */}
            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-bus me-2"></i>
                  Ingresos por Camino
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Registro de ingresos adicionales durante los viajes.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Ingresos</small>
                <h4 className="m-0">
                  ${safeNumberFormat(dataBillsWay.reduce((a, b) => a + parseFloat(b.ingreso || 0), 0))}
                </h4>
              </div>
            </div>

            {/* Tabla de Ingresos por Camino */}
            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-bus me-2"></i> Ingresos por Camino
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="20%" className="text-center">Fecha</th>
                      <th width="20%" className="text-center">Sucursal</th>
                      <th width="20%" className="text-center">Horario</th>
                      <th width="20%" className="text-center">Concepto</th>
                      <th width="20%" className="text-center">Monto</th>
                    </tr>
                  </thead>
                  {dataBillsWay && dataBillsWay.length > 0 ? (
                    <tbody>
                      {(dataBillsWay || []).map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{formatDate(item.fecha_viaje, "date_ticket")}</td>
                          <td className="text-center">{item.branch?.name || 'N/A'}</td>
                          <td className="text-center">{renderScheduleTime(item)}</td>
                          <td className="text-center">{item.notes || 'Sin notas'}</td>
                          <td className="text-center">
                            ${safeNumberFormat(item.ingreso)}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="4" className="text-end"><strong>Total</strong></td>
                        <td className="text-center">
                          <strong>
                            ${safeNumberFormat(dataBillsWay.reduce((a, b) => a + parseFloat(b.ingreso || 0), 0))}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="5" className="text-center">No hay datos para mostrar</td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>

            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-box me-2"></i>
                  Paquetería
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Resumen de envíos y paquetes procesados en la fecha seleccionada.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Paquetería</small>
                <h4 className="m-0">
                  $
                  {safeNumberFormat(dataPackage.reduce((a, b) => a + Number.parseFloat(b.total || 0), 0))}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-box me-2"></i> Paqueteria
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover main table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="20%" className="text-center">
                        Horario
                      </th>
                      <th width="20%" className="text-center">
                        Conductor
                      </th>
                      <th width="20%" className="text-center">
                        Letra
                      </th>
                      <th width="20%" className="text-center">
                        Total
                      </th>
                      <th width="20%" className="text-center">
                        Bitacora
                      </th>
                    </tr>
                  </thead>
                  {dataPackage ? (
                    <tbody>
                      {dataPackage.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{formatTime(item.time)}</td>
                          <td className="text-center">{item.driver}</td>
                          <td className="text-center">{item.letter}</td>
                          <td className="text-center">
                            $
                            {safeNumberFormat(item.total)}
                          </td>
                          <td className="text-center">{item.trip_id}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="3" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {safeNumberFormat(dataPackage.reduce((a, b) => a + Number.parseFloat(b.total || 0), 0))}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    "No hay datos para mostrar"
                  )}
                </table>
              </div>
            </div>

            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-list me-2"></i>
                  Desglose de Paquetería
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Detalle de cada paquete procesado incluyendo destinatario y precio.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Desglose</small>
                <h4 className="m-0">
                  $
                  {safeNumberFormat(packagesToCollect.reduce((a, b) => a + Number.parseFloat(b.price || 0), 0))}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-list-alt me-2"></i> Desglose de Paqueteria
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover main table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="25%" className="text-center">
                        Folio
                      </th>
                      <th width="25%" className="text-center">
                        Destinatario
                      </th>
                      <th width="25%" className="text-center">
                        Descripción
                      </th>
                      <th width="25%" className="text-center">
                        Precio
                      </th>
                    </tr>
                  </thead>
                  {packagesToCollect ? (
                    <tbody>
                      {packagesToCollect.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{item.invoice_number}</td>
                          <td className="text-center">{item.addressee}</td>
                          <td className="text-center">{item.description_package}</td>
                          <td className="text-center">
                            $
                            {safeNumberFormat(item.price)}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="3" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {safeNumberFormat(packagesToCollect.reduce((a, b) => a + Number.parseFloat(b.price || 0), 0))}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    "No hay datos para mostrar"
                  )}
                </table>
              </div>
            </div>

            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-money-bill-wave me-2"></i>
                  Anticipos de Paquetería
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Lista de pagos anticipados recibidos por servicios de paquetería.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Anticipos</small>
                <h4 className="m-0">
                  $
                  {safeNumberFormat(packagesAdvances.reduce((a, b) => a + Number.parseFloat(b.advance || 0), 0))}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-money-bill-wave me-2"></i> Anticipos Paqueterias
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover main table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="20%" className="text-center">
                        Horario
                      </th>
                      <th width="20%" className="text-center">
                        Destinatario
                      </th>
                      <th width="20%" className="text-center">
                        Destino
                      </th>
                      <th width="20%" className="text-center">
                        Monto
                      </th>
                      <th width="20%" className="text-center">
                        Folio
                      </th>
                    </tr>
                  </thead>
                  {packagesAdvances ? (
                    <tbody>
                      {packagesAdvances.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{formatTime(item.time_send)}</td>
                          <td className="text-center">{item.addressee}</td>
                          <td className="text-center">{item.destination.name}</td>
                          <td className="text-center">
                            $
                            {safeNumberFormat(item.advance)}
                          </td>
                          <td className="text-center">{item.invoice_number}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="3" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {safeNumberFormat(packagesAdvances.reduce((a, b) => a + Number.parseFloat(b.advance || 0), 0))}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    "No hay datos para mostrar"
                  )}
                </table>
              </div>
            </div>
            {/* New section for Transfers */}
            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-exchange-alt me-2"></i>
                  Transferencias
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Registro de pagos realizados mediante transferencia bancaria.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Transferencias</small>
                <h4 className="m-0">
                  ${safeNumberFormat(totalTransfers)}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-exchange-alt me-2"></i> Transferencias
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover main table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="30%" className="text-center">
                        Folio / Anotaciones
                      </th>
                      <th width="15%" className="text-center">
                        Fecha Viaje
                      </th>
                      <th width="20%" className="text-center">
                        Fecha de Venta
                      </th>
                      <th width="20%" className="text-center">
                        Taquillero
                      </th>
                      <th width="15%" className="text-center">
                        Monto
                      </th>
                    </tr>
                  </thead>
                  {dataTransfers && dataTransfers.length > 0 ? (
                    <tbody>
                      {dataTransfers.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{item.reference || "-"} / {item.anott}</td>
                          <td className="text-center">{item.date}</td>
                          <td className="text-center">{item.concept || "-"}</td>
                          <td className="text-center">{item.bank || "-"}</td>
                          <td className="text-center">
                            $
                            {safeNumberFormat(item.amount)}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="4" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {safeNumberFormat(totalTransfers)}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="5" className="text-center">
                          No hay datos para mostrar
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>

            {/* New section for Card Payments */}
            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-credit-card me-2"></i>
                  Pagos con Tarjeta
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Registro de pagos realizados mediante tarjeta de crédito o débito.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Tarjetas</small>
                <h4 className="m-0">
                  ${safeNumberFormat(totalCardPayments)}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-credit-card me-2"></i> Pagos con Tarjeta
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover main table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="20%" className="text-center">
                        Folio
                      </th>
                      <th width="20%" className="text-center">
                        Fecha Viaje
                      </th>
                      <th width="20%" className="text-center">
                        Fecha de Venta
                      </th>
                      <th width="20%" className="text-center">
                        Tipo de Tarjeta
                      </th>
                      <th width="20%" className="text-center">
                        Monto
                      </th>
                    </tr>
                  </thead>
                  {dataCardPayments && dataCardPayments.length > 0 ? (
                    <tbody>
                      {dataCardPayments.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{item.reference || "-"}</td>
                          <td className="text-center">{item.date}</td>
                          <td className="text-center">{item.concept || "-"}</td>
                          <td className="text-center">{item.card_type || "-"}</td>
                          <td className="text-center">
                            $
                            {safeNumberFormat(item.amount)}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="4" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {safeNumberFormat(totalCardPayments)}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="5" className="text-center">
                          No hay datos para mostrar
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>

            <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h2 className="earnings-report-title h5 mb-1">
                  <i className="fas fa-calendar-alt me-2"></i>
                  Boletos Preventa
                </h2>
                <p className="earnings-report-description small text-muted mb-2">
                  Listado de boletos pagados con anticipación.
                </p>
              </div>
              <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                <small className="d-block mb-1 text-white-50">Total Preventa</small>
                <h4 className="m-0">
                  $
                  {safeNumberFormat(dataPreTickets.reduce((a, b) => a + Number.parseFloat(b.price_ticket || 0), 0))}
                </h4>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-header">
                <h4 className="card-title m-0 page-sub-title">
                  <i className="fas fa-calendar-check me-2"></i> Boletos Preventa
                </h4>
              </div>
              <div className="card-body">
                <table className="table table-hover main table-striped table-responsive">
                  <thead>
                    <tr>
                      <th width="16%" className="text-center">
                        Folio
                      </th>
                      <th width="16%" className="text-center">
                        Fecha de Viaje
                      </th>
                      <th width="16%" className="text-center">
                        Horario
                      </th>
                      <th width="16%" className="text-center">
                        Precio
                      </th>
                      <th width="16%" className="text-center">
                        Vendedor
                      </th>
                      <th width="16%" className="text-center">
                        Fecha de Compra
                      </th>
                    </tr>
                  </thead>
                  {dataPreTickets ? (
                    <tbody>
                      {dataPreTickets.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{item.invoice}</td>
                          <td className="text-center">{formatDate(item.date_ticket, "date_ticket")}</td>
                          <td className="text-center">{formatTime(item.time_ticket)}</td>
                          <td className="text-center">
                            $
                            {safeNumberFormat(item.price_ticket)}
                          </td>
                          <td className="text-center">{item.seller}</td>
                          <td className="text-center">{formatDate(item.date_created, "date_created")}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="3" className="text-end">
                          <strong>Total</strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            $
                            {safeNumberFormat(dataPreTickets.reduce((a, b) => a + Number.parseFloat(b.price_ticket || 0), 0))}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    "No hay datos para mostrar"
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EarningsReport
